import { DEFAULT_CUSTOMER_FULLNAME } from '@/constants';
import moment from '../moment/moment';

/**
 * @param {string} input
 * @param {any[]} customers 
 * @returns {any[]}
 */
export function filterCustomers(input, customers = []) {
    input = String(input).toLowerCase().trim().replace(/[^A-zÀ-ú]/gm, '');

    if(!input.length || input.length < 3) return [];

    const inputRegex = new RegExp(`^${input}.*`);

    return customers.filter(c => {
        const isLastName = inputRegex.test(c.last_name.toLowerCase());
        const isFirstName =  inputRegex.test(c.first_name.toLowerCase());
        // const isEmail =  inputRegex.test(c.email.toLowerCase());

        const isFullName = inputRegex.test(`${c.first_name} ${c.last_name}`.toLowerCase().trim()) 
        || inputRegex.test(`${c.last_name} ${c.first_name}`.toLowerCase().trim());

        return isFirstName || isLastName || isFullName; //|| isEmail;
    })
};

export const buildBirthDate = (day, month, year = null) => {
    if(!day || !month) return null;
    if(day < 10) day = "0"+parseInt(day);
    if(month < 10) month = "0"+parseInt(month);
    let result = `${month}-${day}`;
    if(year) result = `${year}-${result}`;
    return result;
}

export const getBirthDateInfos = (birthdate = "2000-01-01") => {
    const regex = /^(\d{4}-)?\d{2}-\d{2}$/;
    if(!regex.test(birthdate)) return null;
    let data = birthdate.split('-').map(v => parseInt(v));
    let format = "YYYY-MM-DD";
    if(data.length == 2) {
        data = [null, ...data];
        format = "MM-DD";
    }
    const [year, month, day] = data;
    return { year, month, day, format, input: birthdate };
}

export const formatBirthDate = (birthdate) => {
    const infos = getBirthDateInfos(birthdate);
    if(infos === null) return "";
    const momentObj = moment(infos.input, infos.format);
    if(infos.format === "MM-DD") {
        return momentObj.format("D MMMM");
    }
    else if(infos.format === "YYYY-MM-DD") {
        return momentObj.format("LL");
    }
    else {
        return "";
    }
}

/**
 * 
 * @param {any} customer 
 * @returns {boolean}
 */
export const isCustomerBirthday = (customer = null) => {
    const infos = getBirthDateInfos(customer?.birthdate);
    if(!customer || !infos) return false;
    const birthdate = moment(infos?.input, infos?.format);
    const today = moment();
    return birthdate.date() === today.date() && birthdate.month() === today.month(); 
}

/**
 * 
 * @param {any} customer 
 * @param {string} unit 
 * @returns {number}
 */
export const getCustomerCreationTime = (customer = null, unit = 'years') => {
    if(!customer) return 0;
    const creationDate = moment(customer.created_at);
    const today = moment();
    return today.diff(creationDate, unit);
}

/**
 * 
 * @returns empty customer object
 */
export const getEmptyCustomer = () => ({
    id: null, 
    first_name: "", 
    last_name: "", 
    email: "", 
    phone: "", 
    birthdate: null, 
    comment: null,  
    accept_adds: false,
    created_at: null,
    updated_at: null,
});

export const getCustomerFullName = customer => {
    return `${customer.last_name ?? ''} ${customer.first_name ?? ''}`.trim() || DEFAULT_CUSTOMER_FULLNAME;
}

export function renderCustomerFullName(cellData, customer) {
    const company = (customer.company_name && `- ${customer.company_name}`) ?? "";
    return `${getCustomerFullName(customer)} ${company}`.trim();
} 


// WEBPACK FOOTER //
// ./src/helpers/customers.js